export default "/public/app-main/static/image/fc1eab0cd6d8596ec818f6f59bf568af.png";